<script setup lang="ts">
import { ref, watch } from "vue";
import { api, errorText, useSession } from "../api";
import { TableIcon } from "../icons";
const website = defineModel<string>("website", { required: true });
const enabled = defineModel<boolean>("enabled", { required: true });
const props = defineProps<{ disabled?: boolean; datasetId?: string }>();
const session = useSession(),
  busy = ref(false),
  preview = ref(""),
  error = ref("");
let version = 0;
watch(website, () => {
  version++;
  preview.value = "";
  error.value = "";
});
async function inspect() {
  const current = ++version;
  busy.value = true;
  error.value = "";
  try {
    const result = await api("/api/favicon-previews", {
      method: "POST",
      body: { websiteUrl: website.value, datasetId: props.datasetId },
    });
    if (current === version) {
      preview.value = `/api/favicon-previews/${result.id}?organization=${session.organization}`;
      enabled.value = true;
    }
  } catch (e) {
    if (current === version) error.value = errorText(e);
  } finally {
    busy.value = false;
  }
}
</script>
<template>
  <div class="form-stack website-icon-field">
    <label
      >Website <span class="muted">(valgfrit)</span
      ><input
        v-model="website"
        type="url"
        placeholder="https://eksempel.dk"
        :disabled="disabled"
    /></label>
    <div class="favicon-preview-row">
      <img
        v-if="preview"
        :src="preview"
        width="28"
        height="28"
        alt="Preview af websitets favicon"
        @error="
          preview = '';
          error = 'Ikonet kunne ikke vises. Datasættet kan stadig gemmes.';
        "
      />
      <TableIcon v-else :size="28" />
      <button
        type="button"
        class="button secondary"
        :disabled="disabled || busy || !website"
        @click="inspect"
      >
        {{ busy ? "Henter ikon…" : "Vis favicon" }}
      </button>
    </div>
    <label class="checkbox"
      ><input
        v-model="enabled"
        type="checkbox"
        :disabled="disabled || !website"
      />Brug websitets favicon</label
    >
    <p v-if="error" class="muted small" role="status">
      {{ error }} Du kan gemme uden ikon.
    </p>
  </div>
</template>
<style
  scoped
  lang="scss"
  src="../styles/components/WebsiteIconField.scss"
></style>
